import { LocalizedText, withScopeContext } from '@mews/framework';
import { TextKey, DataTestId } from '@mews-commander/enums';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import { SummaryRow } from '../../SummaryRow';
import { getCheckedReservationsCumulatedOccupancyData } from '../../../../../selectors/summary';
import { openGuestsDialog as openGuestsDialogAction } from '../../../../../actions';
import GuestCountBodyAgeCategories from './GuestCountBodyAgeCategories';

interface GuestCountProps {
    scope: string;
    serviceId: string;
}

const GuestCount = ({ serviceId, scope }: GuestCountProps) => {
    const dispatch = useCommanderThunkDispatch();

    const occupancyData = useCommanderSelector((state) =>
        getCheckedReservationsCumulatedOccupancyData(state, { scope })
    );

    const openGuestsDialog = () => dispatch(openGuestsDialogAction({ scope, serviceId }));

    return (
        <SummaryRow
            action={occupancyData !== null ? openGuestsDialog : undefined}
            dataTestId={DataTestId.ReservationModuleGuestDialog}
            label={<LocalizedText textKey={TextKey.GuestPlural} />}
            body={<GuestCountBodyAgeCategories occupancyData={occupancyData} serviceId={serviceId} />}
        />
    );
};

export default withScopeContext(GuestCount);
